/* Publish by EComposer at 2026-10-09 07:22:20*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-c4qxlbo3jr8"]=  window.__ectimmers["ecom-c4qxlbo3jr8"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),o=t.querySelector(".text-content.ecom-html");!o||(e&&e.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-c4qxlbo3jr8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c4qxlbo3jr8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d1dvvbd05x').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d1dvvbd05x', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dpnqlzbu1bs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dpnqlzbu1bs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j3nsak7d1oi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j3nsak7d1oi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5dmykazd9py').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5dmykazd9py', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qhc0k2bmjy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qhc0k2bmjy', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e3hawcg9x6u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e3hawcg9x6u', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d0b3zcogq06').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d0b3zcogq06', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dde89pcev56').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dde89pcev56', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tcxktoiuln').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tcxktoiuln', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lwkdaml5oy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lwkdaml5oy', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-eia43kss2i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-eia43kss2i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ieykmy8rdkd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ieykmy8rdkd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r813vv9ayss').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r813vv9ayss', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wbtvuwgce5g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wbtvuwgce5g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pmprtsfg2b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pmprtsfg2b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-odrv4s0y63q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-odrv4s0y63q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oaac8t2bkcq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oaac8t2bkcq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uusltygt36').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uusltygt36', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5xdie45udnd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5xdie45udnd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r7vplr4mwcj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r7vplr4mwcj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-szukdbmfnrt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-szukdbmfnrt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4fhx7980zzn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4fhx7980zzn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uvx5pro9qn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uvx5pro9qn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w0c6s53vpx9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w0c6s53vpx9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h29i6my8x4a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h29i6my8x4a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tij2dtdz31').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tij2dtdz31', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qnlcxn11qfb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qnlcxn11qfb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5m6r2qk59lq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5m6r2qk59lq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-aj7eglnhqdu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-aj7eglnhqdu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-45248er5o1o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-45248er5o1o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u487tpjptz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u487tpjptz', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kutb6jmqqlm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kutb6jmqqlm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xwpo2oysj0j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xwpo2oysj0j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d3x77cmxcs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d3x77cmxcs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rurx2zff8qq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rurx2zff8qq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cwkvkw7gwrj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cwkvkw7gwrj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gl5zg0237vi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gl5zg0237vi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7e6xpouks3t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7e6xpouks3t', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7awn2i69bx8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7awn2i69bx8', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-6rhg94zju7l"]=  window.__ectimmers["ecom-6rhg94zju7l"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const o=t.querySelector(".ecom__element--button");if(!o)return;let n=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-6rhg94zju7l"]["0e2t3mqci"] = setInterval(function(){o.classList.add("animated"),setTimeout(function(){o.classList.remove("animated")},s)},n)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let o=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const n=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},o);try{Shopify.analytics.publish("ec_custom_events",n)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-6rhg94zju7l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6rhg94zju7l', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-53mndu4jeli').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-53mndu4jeli', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ayt7757c8xb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ayt7757c8xb', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o6zs5mvwei').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o6zs5mvwei', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bobx0il7jcq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bobx0il7jcq', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-vgfokodxui"]=  window.__ectimmers["ecom-vgfokodxui"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-vgfokodxui"]["z1ea5u596"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let o=this.$el;if(!o)return;function n(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function s(){let r=o.querySelector(".ecom-element.ecom-base-image"),a=o.closest(".core__row--columns");r&&(n(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){s()})

                    });
                    
                        document.querySelectorAll('.ecom-vgfokodxui').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vgfokodxui', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oof960s153j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oof960s153j', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cnaadeoqcca').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cnaadeoqcca', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g1tvk652i4d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g1tvk652i4d', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fvlrczogp1e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fvlrczogp1e', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}